import { render } from "./index.vue?vue&type=template&id=85f9bbc6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=85f9bbc6&lang=css"
script.render = render

export default script